import type { NewsItem } from '@/types';

export const newsList: NewsItem[] = [
  {
    id: 'n1',
    title: '《长夜将明》收官引热议：悬疑剧的耐心叙事还能走多远',
    date: '2025-10-15',
    author: '编辑部 顾南',
    summary:
      '三十六集播完，观众讨论最多的不是凶手是谁，而是那些被慢慢铺开的生活细节。当悬疑剧开始愿意花时间描写人，类型叙事的边界也被推远了一点。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20dim%20interrogation%20room%20with%20a%20single%20desk%20lamp%2C%20an%20empty%20chair%20and%20long%20shadows%20on%20the%20wall%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20background%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=qa-n1-cover&orientation=landscape',
    content: [
      '《长夜将明》在昨晚播出了最后一集。与开播时的低调不同，收官之夜相关话题连续数小时停留在讨论榜前列。观众争论的焦点并不完全集中在案件的最终答案，更多是关于这部剧中那些“看起来可以删掉”的生活段落。',
      '导演周牧野在采访中提到，剧组最初的剧本只有二十四集，后来主动扩写到三十六集，把大量篇幅留给了人物的日常：一次没有结果的走访、一顿沉默的宵夜、一段走了很久的夜路。“如果我们只关心谁做的，那这个故事就太薄了。”他说。',
      '这种选择带来了明显的两面评价。一部分观众认为节奏被拉长，另一部分观众则认为正是这些细节让最后的抉择有了重量。从数据上看，剧集后半程的完播率不降反升，说明耐心叙事并非没有回报。',
      '值得注意的是，本剧在影像上的克制也成为一个话题。全剧几乎不使用强对比色彩，夜景统一在低饱和的青绿色调里，只有关键线索出现时才让暖橙色短暂进入画面。这种视觉上的秩序，与叙事上“慢慢靠近真相”的节奏形成了呼应。',
      '无论评价如何，《长夜将明》至少提供了一个样本：在类型剧高度工业化的今天，仍然有人愿意用更慢的方式讲一个故事。至于这条路能走多远，或许要等下一部作品来回答。',
    ],
  },
  {
    id: 'n2',
    title: '秋季片单前瞻：十部值得走进影院的华语新片',
    date: '2025-10-11',
    author: '特约撰稿 沈禾',
    summary:
      '从科幻到家庭题材，今年秋季的华语片单比想象中更丰富。我们整理了十部值得关注的作品，并标注了各自的看点与适合的观影心情。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20an%20old%20cinema%20entrance%20at%20dusk%20with%20warm%20marquee%20lights%2C%20tickets%20and%20posters%20on%20the%20wall%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20background%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=qa-n2-cover&orientation=landscape',
    content: [
      '进入十月，院线终于迎来一年中最热闹的档期之一。与往年不同的是，今年的华语新片在类型分布上更加分散：科幻、家庭、犯罪、喜剧各有代表，几乎没有明显的“档期霸主”。',
      '最受关注的自然是《星海回声》。这部成本并不算高的科幻片，把大部分预算放在了声音设计和实景搭建上，导演沈方舟称之为“一次关于距离的练习”。影片中几乎没有反派，冲突来自人与时间本身。',
      '家庭题材方面，《灶台之上》用一个回乡主厨的故事，把“好吃”与“被需要”放在一起讨论。影片的厨房戏全部采用自然光拍摄，据说剧组为此重建了一整间老式灶房。',
      '此外，还有几部中小成本作品值得留意：一部以修表铺为舞台的怀旧剧情片，一部在边境公路上完成的动作片，以及一部全部由非职业演员出演的乡村喜剧。它们或许不会成为票房冠军，但构成了这个档期真正的丰富度。',
      '如果你打算在假期里看两三部电影，建议把节奏不同的作品错开安排。毕竟走进影院这件事，除了看什么，也关乎以什么样的心情走进去。',
    ],
  },
  {
    id: 'n3',
    title: '从《巷口茶馆》看年代剧的生活质感从哪里来',
    date: '2025-10-06',
    author: '专栏作者 林一',
    summary:
      '没有宏大场面，也没有强情节反转，这部四十集年代剧靠一张桌子、一壶茶和几代人的日常，留住了观众。年代感并不是道具堆出来的。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20an%20old%20Chinese%20teahouse%20interior%20with%20wooden%20tables%2C%20porcelain%20teacups%20and%20sunlight%20streaming%20through%20paper%20windows%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20background%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=qa-n3-cover&orientation=landscape',
    content: [
      '《巷口茶馆》播出三年，仍然会不时被观众重新提起。它的故事并不复杂：一间茶馆，三任掌柜，四十年时间。但正是这种近乎固执的日常视角，让它在众多年代剧中显得格外耐看。',
      '剧组在美术上的选择非常克制。整间茶馆没有一件“崭新”的道具，桌面有反复擦拭留下的浅痕，墙角的砖被水汽浸出深色，连茶壶盖都根据年代换过三种样式。这些细节不会给特写，但它们在画面里持续起作用。',
      '更关键的是对人的处理。剧中没有绝对的好人或坏人，每个人都在自己的处境里做选择。掌柜的固执、伙计的机灵、老客的沉默，都通过动作而非台词完成。观众记住的不是金句，而是一个人倒茶时手的停顿。',
      '年代剧常常被误解为“复古滤镜加旧物件”，但真正让观众相信时间存在的，是生活逻辑的连贯。茶馆的价钱怎么变、街坊如何打招呼、冬天怎么取暖，这些看似琐碎的问题，构成了年代感的骨架。',
      '从这个意义上说，《巷口茶馆》提供的经验并不复杂：先把日子过对，再谈时代。',
    ],
  },
  {
    id: 'n4',
    title: '流媒体时代的剧集长度：二十四集还是三十六集？',
    date: '2025-09-28',
    author: '行业观察 何川',
    summary:
      '当平台开始用完播率而不是收视率衡量一部剧，集数不再只是创作问题，也是产品问题。我们和三位制片人聊了聊他们如何决定一部剧该有多长。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20modern%20editing%20suite%20with%20multiple%20monitors%20showing%20timelines%2C%20dim%20room%20and%20warm%20desk%20lamp%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20background%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=qa-n4-cover&orientation=landscape',
    content: [
      '十年前，一部国产剧的标准长度是四十集上下。如今打开任何一个流媒体平台，你会看到十二集、十六集、二十四集、三十六集同时存在。集数的变化，背后是观看方式的改变。',
      '一位不愿具名的制片人告诉我们，决定集数的第一个因素往往不是故事，而是排播。“周更和一次性放出，对节奏的要求完全不同。周更需要每一集都有钩子，一次性放出则更看重整体的呼吸感。”',
      '第二个因素是成本结构。场景、演员档期、后期周期都会影响可执行的集数区间。有趣的是，集数增加并不一定摊薄成本，长剧的边际成本在第二十集之后往往开始上升。',
      '观众的感受也在变化。过去“集数多”被视为诚意，现在则更容易被怀疑注水。多个平台的内部数据显示，超过三十集的剧集，中段的流失率明显高于短剧，但如果中段能够提供足够的情感回报，完播率反而更稳定。',
      '所以问题或许不是二十四集还是三十六集，而是每一集是否都有存在的理由。长度本身不会拯救一个故事，也不会毁掉它。',
    ],
  },
  {
    id: 'n5',
    title: '动画电影幕后：手绘与三维之间的那条边界',
    date: '2025-09-19',
    author: '特约撰稿 苏禾',
    summary:
      '在《星轨列车》的制作特辑里，最让人意外的不是技术，而是团队对“不完美”的坚持。手绘线条为何仍然重要？我们走进了这部作品的美术组。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20an%20animation%20studio%20desk%20with%20hand%20drawn%20storyboards%2C%20colored%20pencils%20and%20a%20light%20table%2C%20warm%20lamp%20glow%20in%20a%20dim%20room%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20background%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=qa-n5-cover&orientation=landscape',
    content: [
      '《星轨列车》里有一场只有四十秒的戏：列车穿过一片星云，窗外的光一点点漫进车厢。这场戏在成片里看起来流畅自然，实际上由三位动画师手工绘制了近两千张中间帧。',
      '美术指导在采访中说，团队并不是排斥三维技术。“我们用三维做 layout，确认镜头运动和空间关系，但最终呈现的线条一定是手绘的。因为手绘会有轻微的抖动，那种抖动让画面有呼吸。”',
      '这种选择带来了巨大的工作量。为了控制周期，制作组把全片划分为若干个视觉单元，每个单元由一位作画监督统一风格。观众可能不会注意，但不同段落的光线倾向其实有细微差别。',
      '音乐同样是这部作品的重要部分。作曲家使用了大量真实的钢片琴和钟琴，而非合成音色，理由是“星光的质感需要一点点金属的余韵”。',
      '技术会继续进步，但这部作品提醒我们：观众真正记住的，往往不是分辨率，而是某一帧里那点笨拙的、属于人的痕迹。',
    ],
  },
  {
    id: 'n6',
    title: '影视配乐专题：当旋律成为第二个主角',
    date: '2025-09-12',
    author: '音乐专栏 陈默',
    summary:
      '一段好的配乐不需要被记住旋律，它只需要在对的时刻出现。我们梳理了近两年几部作品中的配乐设计，看看声音如何参与叙事。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20recording%20studio%20with%20a%20grand%20piano%2C%20sheet%20music%20and%20a%20microphone%20in%20warm%20low%20light%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20background%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=qa-n6-cover&orientation=landscape',
    content: [
      '很多人以为配乐的作用是“烘托情绪”，但真正成熟的配乐往往在做的恰恰相反：它制造一种情绪，然后让画面去反驳它。',
      '在《雾港谜案》中，作曲家几乎全程使用低频弦乐，只有主角回到旧仓库时才加入一段单簧管。这段旋律在片中出现了四次，每次的编曲都比上一次更空，直到最后一次只剩一个延音。',
      '《海风旅店》的做法更轻。全剧的主题动机只有五个音，用不同的乐器演奏出不同的温度。同一段旋律，在清晨是钢琴，在深夜是口琴，观众未必能说出区别，但会感觉到时间变了。',
      '配乐最难的部分其实是“留白”。一位从业二十年的作曲者说，他工作中有一半时间在决定哪里不加音乐。“ silence 也是一种配器。”',
      '下次看剧时，不妨留意一下声音消失的那几秒。很多时候，故事最重要的转折就发生在那里。',
    ],
  },
  {
    id: 'n7',
    title: '编剧谈改编：把小说搬上屏幕，最先要放弃的是什么',
    date: '2025-09-04',
    author: '编辑部 顾南',
    summary:
      '改编从来不是照搬。三位编剧分享了他们在结构、人物和台词上做出的取舍，以及那些最终没能出现在成片里的段落。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20writer%20desk%20with%20stacked%20novels%2C%20handwritten%20notes%2C%20a%20typewriter%20and%20a%20cup%20of%20tea%20in%20morning%20light%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20background%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=qa-n7-cover&orientation=landscape',
    content: [
      '改编一部小说，最先要放弃的往往不是情节，而是叙述者。小说可以用一整章描写一个人的内心，影像不行。于是编剧必须把这些想法翻译成动作、停顿和选择。',
      '一位编剧把改编比作搬家：“你不能把整间屋子抬走，只能挑一些真正需要的东西，然后在新的地方重新布置。”她最近完成的一部作品，删掉了原著中一个颇受欢迎的角色，理由是“他在剧里没有自己的时间”。',
      '结构上的调整同样普遍。小说的章节可以自由跳跃，剧集却需要让观众在每一集结束时愿意回来。这就意味着要重新分配悬念，有时甚至要把结尾的信息提前。',
      '最难处理的是台词。越是文学性强的作品，越容易在改编时出现“演员在念书”的感觉。解决办法听起来很朴素：让角色去做一件具体的事，边做边说。',
      '观众常常讨论改编是否“忠于原著”。但对创作者来说，更实际的标准是：这个故事在新的媒介里，是否还能自己站住。',
    ],
  },
  {
    id: 'n8',
    title: '一周新片速览：五部作品上线，两种截然不同的节奏',
    date: '2025-08-29',
    author: '资讯组',
    summary:
      '本周共有五部新作上线，其中两部选择慢节奏的生活流叙事，另外三部则在类型上做足文章。我们给出了各自的观看建议。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photograph%20of%20a%20cozy%20small%20movie%20theater%20with%20empty%20teal%20seats%20and%20a%20glowing%20screen%2C%20warm%20aisle%20lights%2C%20muted%20teal%20and%20warm%20amber%20palette%2C%20soft%20film%20grain%2C%20atmospheric%20light%2C%20simple%20clean%20background%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=qa-n8-cover&orientation=landscape',
    content: [
      '本周上线的五部作品中，最受关注的是科幻片《星海回声》与家庭喜剧《灶台之上》。前者把注意力放在声音与空间上，后者则回到厨房和餐桌，两种完全不同的节奏，恰好构成了这个周末的选择。',
      '《星海回声》适合在安静的环境里观看，最好戴上耳机。影片大量使用环境声与低频音效，很多信息藏在声音的层次里。如果开着弹幕或倍速播放，可能会错过它最重要的部分。',
      '《灶台之上》则是另一种体验。它的笑点密集但不喧闹，情绪推进依靠一顿顿饭完成。建议不要在深夜空腹观看，片中出现的每一道菜都拍得过于认真。',
      '其余三部中，一部边境公路题材动作片节奏最快，一部纪录片式的乡村喜剧最放松，还有一部小成本悬疑片适合喜欢推理的观众。',
      '如果时间有限，我们的建议是：想看画面选科幻，想放松选喜剧，想动脑选悬疑。剩下的，留给下一个周末。',
    ],
  },
];